import { connect } from 'react-redux';
import notifyAction from '../redux/actions/notification';
import ExchangeSelect from '../components/exchange/ExchangeSelect';

const mapStateToProps = (state) => ({
  notifies: state.notification.userNotifications || [],
  info: state.user.info,
  coins: state.setting.coins,
  currencyMarkets: state.setting.currencyMarkets,
});

const mapDispatchToProps = (dispatch) => ({
  // onFetchNotify: (params, callback = () => void (0)) => {
  //   dispatch(notifyAction.fetchNotifyAction(params, callback));
  // },
  fetchUserNotifications: (params, callback) => {
    dispatch(notifyAction.fetchUserNotifications(params, callback));
  },
  fetchMarkedNotifications: (params, callback) => {
    dispatch(notifyAction.fetchMarkedNotifications(params, callback));
  },
  checkedUserNotifications: (params, callback) => {
    dispatch(notifyAction.checkedUserNotifications(params, callback));
  },
  checkedAllUserNotifications: (params, callback) => {
    dispatch(notifyAction.checkedAllUserNotifications(params, callback));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(ExchangeSelect);
